export interface AttendanceRecord {
  checkIn?: string | null
  checkOut?: string | null
}

export type Phase = 'before' | 'active' | 'finished'

/**
 * Which of the three states today's attendance row is in — `FRONTEND.md` §9.32.
 *
 * Legacy's, and the whole interface the sidebar widget has: a row with no `checkIn` has not started,
 * one with a `checkIn` and no `checkOut` is running, one with both is done.
 *
 * **A missing record is `before`.** The row is created by the first punch, so *nothing recorded today*
 * and *has not arrived yet* are the same state and must not be told apart — treating a null record as
 * its own case is how a widget ends up with a fourth phase that offers nothing on the one morning it
 * matters.
 */
export function phaseOf(record: AttendanceRecord | null | undefined): Phase {
  if (!record?.checkIn) return 'before'
  return record.checkOut ? 'finished' : 'active'
}
